<div class="map-menu-item">
  <div class="header header--default">
    <h3 class="p-0 border-0">Property and Sales</h3>
  </div>
  <div class="scroll-container">
    <ng-container *ngIf="distressedProperties$ | async as distressedProperties">
      <rlst-expandable-item
        title="Distressed Properties"
        *ngIf="distressedProperties.length"
        [expanded]="false"
        (click)="$event.stopPropagation()"
        [index]="index">
        <div class="js-panel-header panel-header"></div>
        <div class="expanded-container position-relative">
          <ul class="att-list p-0 m-0" (click)="$event.stopPropagation()">
            <li mat-menu-item role="menuitemcheckbox" *ngFor="let layer of distressedProperties; trackBy: trackByLayerId" class="map-layer">
              <label class="custom-control custom-checkbox att-list__label" tabindex="0"
                     [ngClass]="{'custom-control--disabled': isLayerDisabled(layer)}">
                <input type="checkbox" class="custom-control-input checkbox-default"
                       [checked]="layer.isSelected"
                       [disabled]="isLayerDisabled(layer)"
                       (click)="toggleDistressedProperty(layer)">
                <span class="custom-control-indicator"></span>
                <span *ngIf="layer.iconClass" class="layer-icon" [ngClass]="layer.iconClass"></span>
                <span class="layer-text">{{layer.label}}</span>
              </label>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
                <i class="far fa-search-plus" aria-hidden="true"></i>
                <span class="sr-only">Zoom In</span>
              </p>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
                <i class="far fa-search-minus" aria-hidden="true"></i>
                <span class="sr-only">Zoom Out</span>
              </p>
            </li>
          </ul>
        </div>
      </rlst-expandable-item>
    </ng-container>

    <ng-container *ngIf="salesValues$ | async as salesValues">
      <rlst-expandable-item
        title="Sales and Values"
        *ngIf="salesValues.length"
        [expanded]="false"
        (click)="$event.stopPropagation()"
        [index]="index">
        <div class="js-panel-header panel-header"></div>
        <div class="expanded-container position-relative">
          <ul class="att-list p-0 m-0" (click)="$event.stopPropagation()">
            <li mat-menu-item role="menuitemcheckbox" *ngFor="let layer of salesValues; trackBy: trackByLayerId" class="map-layer">
              <label class="custom-control custom-checkbox att-list__label" tabindex="0"
                     [ngClass]="{'custom-control--disabled': isLayerDisabled(layer)}">
                <input type="checkbox" class="custom-control-input checkbox-default"
                       [checked]="layer.isSelected"
                       [disabled]="isLayerDisabled(layer)"
                       (click)="toggleSalesValue(layer)">
                <span class="custom-control-indicator"></span>
                <span *ngIf="layer.iconClass" class="layer-icon" [ngClass]="layer.iconClass"></span>
                <span class="layer-text">{{layer.label}}</span>
                <select *ngIf="layer.subLayers" class="custom-select custom-select-search custom-select-rtl"
                        (change)="toggleSalesValue(layer.subLayers[$event.target.selectedIndex])">
                  <option *ngFor="let subLayer of layer.subLayers; trackBy: trackByLayerId"
                          class="rtl-option"
                          [selected]="subLayer.isSelected">
                    {{subLayer.label}}
                  </option>
                </select>
              </label>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
                <i class="far fa-search-plus" aria-hidden="true"></i>
                <span class="sr-only">Zoom In</span>
              </p>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
                <i class="far fa-search-minus" aria-hidden="true"></i>
                <span class="sr-only">Zoom Out</span>
              </p>
            </li>
          </ul>
        </div>
      </rlst-expandable-item>
    </ng-container>

    <ng-container *ngIf="mlsListings$ | async as mlsListings">
      <rlst-expandable-item
        title="MLS Status"
        *ngIf="mlsListings.length"
        [expanded]="false"
        [noTitlecase]="true"
        (click)="$event.stopPropagation()"
        [index]="index">
        <div class="js-panel-header panel-header"></div>
        <div class="expanded-container position-relative">
          <ul class="att-list p-0 m-0" (click)="$event.stopPropagation()">
            <li mat-menu-item role="menuitemcheckbox" *ngFor="let layer of mlsListings; trackBy: trackByLayerId" class="map-layer">
              <label class="custom-control custom-checkbox att-list__label" tabindex="0"
                     [ngClass]="{'custom-control--disabled': isLayerDisabled(layer)}">
                <input type="checkbox" class="custom-control-input checkbox-default"
                       [checked]="layer.isSelected"
                       [disabled]="isLayerDisabled(layer)"
                       (click)="toggleMlsListing(layer)">
                <span class="custom-control-indicator"></span>
                <span *ngIf="layer.iconClass" class="layer-icon" [ngClass]="layer.iconClass"></span>
                <span class="layer-text">{{layer.label}}</span>
                <select *ngIf="layer.subLayers" class="custom-select custom-select-search custom-select-rtl"
                        (change)="toggleMlsListing(layer.subLayers[$event.target.selectedIndex])">
                  <option *ngFor="let subLayer of layer.subLayers; trackBy: trackByLayerId"
                          class="rtl-option"
                          [selected]="subLayer.isSelected">
                    {{subLayer.label}}
                  </option>
                </select>
              </label>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
                <i class="far fa-search-plus" aria-hidden="true"></i>
                <span class="sr-only">Zoom In</span>
              </p>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
                <i class="far fa-search-minus" aria-hidden="true"></i>
                <span class="sr-only">Zoom Out</span>
              </p>
            </li>
          </ul>
        </div>
      </rlst-expandable-item>
    </ng-container>

    <ng-container *ngIf="propertyCharacteristics$ | async as propertyCharacteristics">
      <rlst-expandable-item
        title="Property Characteristics"
        *ngIf="propertyCharacteristics.length"
        [expanded]="false"
        (click)="$event.stopPropagation()"
        [index]="index">
        <div class="js-panel-header panel-header"></div>
        <div class="expanded-container position-relative">
          <div role="radiogroup" class="custom-control-stacked"
               (click)="$event.stopPropagation()"
               *ngIf="selectedPropertyCharacteristic$ | async as selectedPropertyCharacteristic">
            <label *ngFor="let layer of propertyCharacteristics; trackBy: trackByLayerId"
                   class="custom-control custom-radio d-flex align-items-center justify-content-between"
                   [ngClass]="{'custom-control--disabled': isLayerDisabled(layer)}">
              <input [value]="layer.label"
                     [checked]="layer.layerId === selectedPropertyCharacteristic?.layerId"
                     [disabled]="isLayerDisabled(layer)"
                     (change)="setPropertyCharacteristic(layer)"
                     tabindex="0"
                     type="radio"
                     name="property-characteristics"
                     class="custom-control-input radio-primary">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{layer.label}}</span>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
                <i class="far fa-search-plus" aria-hidden="true"></i>
                <span class="sr-only">Zoom In</span>
              </p>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
                <i class="far fa-search-minus" aria-hidden="true"></i>
                <span class="sr-only">Zoom Out</span>
              </p>
            </label>
          </div>
        </div>
      </rlst-expandable-item>
    </ng-container>

    <ng-container *ngIf="locationInformation$ | async as locationInformation">
      <rlst-expandable-item
        title="Location Information"
        *ngIf="locationInformation.length"
        [expanded]="false"
        (click)="$event.stopPropagation()"
        [index]="index">
        <div class="js-panel-header panel-header"></div>
        <div class="expanded-container position-relative">
          <ul class="att-list p-0 m-0" (click)="$event.stopPropagation()">
            <li mat-menu-item role="menuitemcheckbox" *ngFor="let layer of locationInformation; trackBy: trackByLayerId" class="map-layer">
              <label class="custom-control custom-checkbox att-list__label" tabindex="0"
                     [ngClass]="{'custom-control--disabled': isLayerDisabled(layer)}">
                <input type="checkbox" class="custom-control-input checkbox-default"
                       [checked]="layer.isSelected"
                       [disabled]="isLayerDisabled(layer)"
                       (click)="toggleLocationInformation(layer)">
                <span class="custom-control-indicator"></span>
                <span *ngIf="layer.color" class="layer-color-block" [ngStyle]="{backgroundColor: layer.color}"></span>
                <span class="layer-text">{{layer.label}}</span>
              </label>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomIn" rlstTooltip="Zoom In" [tooltipPosition]="'above'">
                <i class="far fa-search-plus" aria-hidden="true"></i>
                <span class="sr-only">Zoom In</span>
              </p>
              <p class="text-danger m-0 p-0 zoom-icon" *ngIf="layer.needZoomOut" rlstTooltip="Zoom Out" [tooltipPosition]="'above'">
                <i class="far fa-search-minus" aria-hidden="true"></i>
                <span class="sr-only">Zoom Out</span>
              </p>
            </li>
          </ul>
        </div>
      </rlst-expandable-item>
    </ng-container>
  </div>
  <div class="info-lane info-lane--default">
    <rlst-map-layers-info-footer></rlst-map-layers-info-footer>
  </div>
</div>
